// Which deployment this console is talking to, from its own host name. Its own module so the
// sign-in page can name it without importing the console shell (#583 S6b2 fix round 1, L3).
export const environmentOf = (host) => ({ 'admin.chorestory.com': 'Production', 'admin.bobross.chorestory.com': 'Development' })[host] || 'Local';
